"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

// TODO(alipianu): keep in sync with Figma (synced from https://www.figma.com/design/qcB5qVN7uKBBYHN49ihDE7/Slate-Icons?node-id=1737-489&m=dev)
/** @optimized using svgo:^3.0.2 */
export const ShopifyColored = createSVGIcon(
  <>
    <path
      d="M19.938 4.623a.225.225 0 0 0-.213-.193c-.096 0-1.798-.039-1.798-.039S16.496 3 16.36 2.863c-.135-.135-.425-.096-.522-.058 0 0-.27.078-.715.213a5.7 5.7 0 0 0-.348-.85c-.503-.968-1.257-1.49-2.147-1.49-.058 0-.116 0-.193.02-.02-.04-.058-.059-.078-.097-.386-.426-.889-.619-1.489-.6-1.16.039-2.32.87-3.248 2.36-.658 1.044-1.16 2.359-1.315 3.384-1.335.406-2.263.696-2.282.715-.677.213-.696.232-.774.87-.058.484-1.837 14.117-1.837 14.117L16.186 24l6.401-1.586c-.019-.02-2.63-17.675-2.649-17.79m-5.55-1.373c-.348.097-.735.232-1.14.348 0-.58-.078-1.411-.349-2.108.87.174 1.296 1.16 1.489 1.76m-1.934.6c-.773.232-1.624.502-2.475.754.232-.91.696-1.818 1.238-2.417.212-.213.502-.465.831-.62.348.678.426 1.625.406 2.283M10.888.775q.406 0 .696.174c-.31.174-.619.406-.909.715-.735.793-1.296 2.03-1.528 3.21l-2.03.62c.406-1.857 1.972-4.661 3.77-4.72"
      fill="#95BF47"
    />
    <path
      d="M19.725 4.43c-.096 0-1.798-.039-1.798-.039S16.496 3 16.36 2.863a.37.37 0 0 0-.192-.096V23.98l6.4-1.586-2.63-17.791a.23.23 0 0 0-.213-.174"
      fill="#5E8E3E"
    />
    <path
      d="m12.61 7.717-.735 2.785s-.832-.387-1.818-.31c-1.45.097-1.45 1.006-1.45 1.238.077 1.238 3.345 1.508 3.538 4.429.136 2.3-1.218 3.867-3.171 3.983-2.36.155-3.655-1.237-3.655-1.237l.503-2.128s1.295.987 2.34.91c.676-.04.928-.6.909-.987-.097-1.624-2.766-1.528-2.94-4.196-.135-2.244 1.334-4.525 4.583-4.719 1.257-.097 1.896.232 1.896.232"
      fill="#FFF"
    />
  </>,
  "ShopifyColored",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    titleAccess: strictLocalize({
      id: "z5k00S",
      defaultMessage: "Shopify logo",
      description: { text: "The label for Shopify's company logo icon" },
    }),
  })
);
